/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { N as Note, d as defineCustomElement$1 } from './note.js';

const IonNote = Note;
const defineCustomElement = defineCustomElement$1;

export { IonNote, defineCustomElement };
